import { Col, Row, Typography } from "antd";
import { services } from "./data";

const ServicesSection = () => {
  return (
    <section className="section-margin-top container services-section">
      <Typography.Title level={2} className="m-0">
        Our Services
      </Typography.Title>
      <Row gutter={[20, 40]} className="services-wrapper">
        {services.map((service, key) => (
          <Col key={key} xs={24} sm={12} md={8} lg={8} xl={8} xxl={6}>
            <ServiceCard {...service} isFirst={key === 0} />
          </Col>
        ))}
      </Row>
    </section>
  );
};

export default ServicesSection;

const ServiceCard = ({ icon, title, desc, href, isFirst }) => (
  <div className={`service-card ${isFirst ? "first" : ""}`}>
    <div className="service-card-icon">
      {icon}
    </div>
    <div className="service-card-content">
      <Typography.Title level={4} className="m-0">
        {title}
      </Typography.Title>
      <Typography.Paragraph className="m-0">{desc}</Typography.Paragraph>
      {/* <button
        className="notched-primary-btn contact-us-btn"
        onClick={() => window.open(href)}
      >
        Learn More
      </button> */}
    </div>
  </div>
);
